import { Component, Input, OnInit } from '@angular/core';
import { Observable, Subject, ReplaySubject } from 'rxjs/';
import { ProductsService } from 'app/agora/components/product-data/products/products.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { ConfigService } from 'app/core/services/config.service';

@Component({
  selector: 'itpx-product-variant-edit-renders',
  templateUrl: './product-variant-edit-renders.component.html',
  styleUrls: ['./product-variant-edit-renders.component.css']
})
export class ProductVariantEditRendersComponent implements OnInit {

  @Input() form: FormGroup;
  @Input() details: any;
  
  private type: Array<any> = ['png', 'jpeg'];
  private bucket: string = this.configService.get('aws').sellerProductUploadsBucket;

  constructor(
    private service: ProductsService,
    private configService: ConfigService
  ) { }

  ngOnInit() {
  }

  onUploadImage(event: any) {
    let updateObj = {
      rootImageKey: event.data.key,
      rootImageBucket: event.data.bucket
    }
    
    this.form.controls.renders['controls'][0].patchValue(updateObj)
  }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/product-variants/edit/renders/product-variant-edit-renders.component.ts